/**
 * Reading a fare's parts out of the shapes the results screens hold it in.
 */

/**
 * The agency's service fee on an offer — its own margin inside the quoted total.
 *
 * Shown as a line in the fare breakdown beside taxes, so the customer can see
 * what the total is made of.
 */
export function serviceFeeOf(flightData: any, tier?: any): number {
    // Three shapes, because callers hold the fare at different depths: a tier
    // wrapping its group (the results accordion), the group itself (the booking
    // popup, which has already unwrapped it), or nothing but the itinerary.
    //
    // Order matters. The itinerary carries the markup for its *default* fare, so
    // falling back to it when a specific tier was chosen shows a different
    // fare's fee — a wrong number that looks entirely plausible.
    const fee =
        tier?.fullGroup?.markup?.serviceFee ??
        tier?.markup?.serviceFee ??
        flightData?.markup?.serviceFee ??
        0;
    const n = Number(fee);
    return Number.isFinite(n) && n > 0 ? n : 0;
}
